/** 角色类型 */
export const TabType = {
    /** 充值订单 */
    RechargeOrder: 'RechargeOrder',
};

/** 默认列表字段 */
export const DefaultListFeilds = {

    /** 支付单号 */
    id: 'payId',

    /** 第三方单号 */
    otherId: 'outPayId',

    /** 会员手机号 */
    tel: 'phone',

    /** 会员昵称 */
    name: 'name',

    /** 充值金额（元） */
    rechargeAmount: 'rechargeAmount',

    /** 赠送金额（元） */
    giveAmount: 'giftAmount',

    /** 手续费（元） */
    serviceFee: 'fee',

    /** 充值来源 */
    rechargeSource: 'deviceType',
    rechargeSourceDesc: 'deviceType',

    /** 设备ID */
    deviceId: 'deviceId',

    /** 充值城市 */
    rechargeCity: 'rechargeCity',

    /** 支付方式 */
    payType: 'accessType',
    payTypeDesc: 'accessType',

    /** 支付时间 */
    payTime: 'payTime',

    /** 发票号 */
    invoiceId: 'invoiceNo',

    /** 备注 */
    remark: 'invoiceMemo',

    /** 充值手机号关联用户Id */
    userId: 'userId'
};

/** 详情页面字段 */
export const DefaultDetailFields = {

    /** 操作 */
    operation: 'postStatusDescript',

    /** 操作备注 */
    operateRemark: 'comment',

    /** 操作人 */
    operator: 'auditUserName',

    /** 操作时间 */
    operateTime: 'gmtCreate'
};

